<a (click)="onNavigationClick.emit(item)"
   class="pointer"
   id="nav_item_{{item.identify}}"
   [ngClass]="{
   'sub-title-first': isFirst,
   'tab-selected': selected && !isDropdown,
   'selected': selected && isDropdown,
   'gen-navigation-bar-item-dropdown' : isDropdown,
   'title': !isDropdown,
   'sub-title-next': !isFirst && !isDropdown }">
    {{item.text | translate}}
</a>
